// import external dependencies
import 'jquery';

import 'slick-carousel/slick/slick.min.js';

import 'reframe.js/dist/reframe.js';

import 'lity';

import 'smoothscroll-polyfill/dist/smoothscroll.js';

import 'imagesloaded/imagesloaded.pkgd.js';

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import singleArtist from './routes/single-artist';
import postTypeArchiveArtist from './routes/post-type-archive-artist';
import postTypeArchiveShowtime from './routes/post-type-archive-showtime';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  singleArtist,
  postTypeArchiveArtist,
  postTypeArchiveShowtime,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js